(() => {
  const root = document.querySelector(
    '.product-single--cro-tortakit[data-product-handle="setdecorazioni"]',
  );

  if (!root) {
    return;
  }

  document.body.classList.add("pdp-cro-tortakit-active");

  const mainSelect = root.querySelector(
    'select[id^="MainProductSelect-"]',
  );
  const productJson =
    document.querySelector("[id^='ProductJson-'].mainProductJson") ||
    document.querySelector("[id^='ProductJson-']");
  const cards = Array.from(
    root.querySelectorAll("[data-tortakit-variant-card]"),
  );
  const sticky = root.querySelector("[data-cro-tortakit-sticky]");
  const purchasePanel = root.querySelector(
    "[data-tortakit-purchase-panel]",
  );
  const stickyVariant = sticky?.querySelector(
    "[data-tortakit-sticky-variant]",
  );
  const stickyPrice = sticky?.querySelector(
    "[data-tortakit-sticky-price]",
  );
  let productData = null;
  let isSyncing = false;
  let purchaseIsVisible = true;
  let finalSectionIsVisible = false;

  if (productJson) {
    try {
      productData = JSON.parse(productJson.textContent);
    } catch {
      productData = null;
    }
  }

  const formatMoney = (cents) => {
    const value = Number(cents || 0) / 100;
    return `€${new Intl.NumberFormat("it-IT", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)}`;
  };

  const getVariant = (variantId) =>
    productData?.variants?.find(
      (variant) => String(variant.id) === String(variantId),
    ) || null;

  const getCurrentVariant = () =>
    getVariant(mainSelect?.value) ||
    getVariant(
      cards.find((card) => card.classList.contains("is-selected"))?.dataset
        .variantId,
    );

  const getShortVariantLabel = (variant) =>
    String(variant?.option1 || variant?.title || "")
      .split(" A ")[0]
      .trim();

  const pushEvent = (eventName, extra = {}) => {
    const variant = getCurrentVariant();
    const payload = {
      event: eventName,
      product_id: String(productData?.id || root.dataset.productId || ""),
      product_handle: "setdecorazioni",
      variant_id: variant ? String(variant.id) : null,
      variant_title: variant?.title || null,
      value: variant ? Number(variant.price) / 100 : null,
      currency: "EUR",
      ...extra,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(
      new CustomEvent(`tortakit:${eventName}`, { detail: payload }),
    );
  };

  const updateVariantUi = (variant) => {
    if (!variant) {
      return;
    }

    cards.forEach((card) => {
      const selected =
        String(card.dataset.variantId) === String(variant.id);
      card.classList.toggle("is-selected", selected);
      card.setAttribute("aria-pressed", selected ? "true" : "false");
    });

    if (stickyVariant) {
      stickyVariant.textContent = getShortVariantLabel(variant);
    }
    if (stickyPrice) {
      stickyPrice.textContent = formatMoney(variant.price);
    }

    const priceElement = root.querySelector("#ProductPrice");
    const priceMoney = priceElement?.querySelector(".money");
    const compareElement = root.querySelector("#ComparePrice");
    const compareMoney = compareElement?.querySelector(".money");
    const onSale =
      Number(variant.compare_at_price || 0) > Number(variant.price || 0);

    if (priceMoney) {
      priceMoney.textContent = formatMoney(variant.price);
    }
    if (priceElement) {
      priceElement.setAttribute(
        "content",
        String(Number(variant.price || 0) / 100),
      );
      priceElement.classList.toggle("on-sale", onSale);
    }
    if (compareMoney && onSale) {
      compareMoney.textContent = formatMoney(variant.compare_at_price);
    }
    compareElement?.classList.toggle("hide", !onSale);
  };

  const syncFormVariantInputs = (variantId) => {
    root
      .querySelectorAll('select[name="id"], input[name="id"]')
      .forEach((input) => {
        if (String(input.value) !== String(variantId)) {
          input.value = String(variantId);
        }
      });
  };

  const selectVariant = (card) => {
    if (isSyncing || card.disabled) {
      return;
    }

    const variantId = card.dataset.variantId;
    const optionValue = card.dataset.optionValue;
    const variant = getVariant(variantId);
    if (!variant) {
      return;
    }

    isSyncing = true;
    try {
      const optionInputs = Array.from(
        root.querySelectorAll(".js-single-option-selector"),
      );
      const radio = optionInputs.find(
        (input) =>
          input.type === "radio" && input.value === optionValue,
      );
      const optionSelect = optionInputs.find(
        (input) => input.tagName === "SELECT",
      );

      if (radio && !radio.checked) {
        radio.checked = true;
      } else if (optionSelect && optionSelect.value !== optionValue) {
        optionSelect.value = optionValue;
      }

      if (mainSelect) {
        if (String(mainSelect.value) !== String(variantId)) {
          mainSelect.value = String(variantId);
        }
      }

      syncFormVariantInputs(variantId);
      updateVariantUi(variant);
      pushEvent("tortakit_variant_selected");
    } finally {
      window.setTimeout(() => {
        isSyncing = false;
      }, 80);
    }
  };

  cards.forEach((card) => {
    card.addEventListener("click", () => selectVariant(card));
  });

  root
    .querySelectorAll(".js-single-option-selector")
    .forEach((input) => {
      input.addEventListener("change", () => {
        window.setTimeout(() => {
          const variant = getVariant(mainSelect?.value);
          if (variant) {
            updateVariantUi(variant);
            syncFormVariantInputs(variant.id);
          }
        }, 100);
      });
    });

  mainSelect?.addEventListener("change", () => {
    const variant = getVariant(mainSelect.value);
    updateVariantUi(variant);
    if (variant) {
      syncFormVariantInputs(variant.id);
    }
  });

  const gallery = root.querySelector("[data-tortakit-gallery]");
  const galleryMain = gallery?.querySelector(
    "[data-tortakit-gallery-main]",
  );
  const galleryThumbs = Array.from(
    gallery?.querySelectorAll("[data-tortakit-gallery-thumb]") || [],
  );

  galleryThumbs.forEach((thumb) => {
    const preload = new Image();
    preload.src = thumb.dataset.src;

    thumb.addEventListener("click", () => {
      if (!galleryMain || thumb.classList.contains("is-active")) {
        return;
      }

      galleryMain.classList.add("is-changing");
      galleryThumbs.forEach((candidate) => {
        const selected = candidate === thumb;
        candidate.classList.toggle("is-active", selected);
        if (selected) {
          candidate.setAttribute("aria-current", "true");
        } else {
          candidate.removeAttribute("aria-current");
        }
      });

      window.setTimeout(() => {
        galleryMain.src = thumb.dataset.src;
        galleryMain.alt = thumb.dataset.alt || "";
        galleryMain.width = Number(thumb.dataset.width || 900);
        galleryMain.height = Number(thumb.dataset.height || 1200);
        galleryMain.addEventListener(
          "load",
          () => galleryMain.classList.remove("is-changing"),
          { once: true },
        );
        window.setTimeout(
          () => galleryMain.classList.remove("is-changing"),
          450,
        );
      }, 80);

      pushEvent("tortakit_gallery_view", {
        image_alt: thumb.dataset.alt || null,
      });
    });
  });

  const hideDuplicateEasySellSticky = () => {
    document
      .querySelectorAll(
        "#es-sticky, .es-sticky-btn.es-sticky-product, .es-sticky-product.es-sticky-top",
      )
      .forEach((element) => {
        element.setAttribute("aria-hidden", "true");
        element.style.setProperty("display", "none", "important");
        element.style.setProperty("pointer-events", "none", "important");
      });
  };

  hideDuplicateEasySellSticky();
  const easySellObserver = new MutationObserver(() => {
    hideDuplicateEasySellSticky();
  });
  easySellObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
  window.setTimeout(() => easySellObserver.disconnect(), 30000);

  const openEasySell = async (source) => {
    const variant = getCurrentVariant();
    if (variant) {
      syncFormVariantInputs(variant.id);
    }

    pushEvent("tortakit_checkout_open", {
      payment_method: "cash_on_delivery",
      source,
    });

    if (variant && typeof window.fbq === "function") {
      const storageKey = `tortakit_ic_${variant.id}`;
      let alreadyTracked = false;
      try {
        alreadyTracked = window.sessionStorage.getItem(storageKey) === "1";
      } catch {
        alreadyTracked = false;
      }

      if (!alreadyTracked) {
        window.fbq("track", "InitiateCheckout", {
          content_ids: [String(variant.id)],
          content_name: productData?.title || "Set Decorazioni a Fiori per Torte",
          content_type: "product",
          currency: "EUR",
          num_items: 1,
          value: Number(variant.price) / 100,
        });
        try {
          window.sessionStorage.setItem(storageKey, "1");
        } catch {
          // Tracking still works when storage is unavailable.
        }
      }
    }

    for (let attempt = 0; attempt < 30; attempt += 1) {
      const originalButton = document.querySelector("#es-popup-button");
      if (originalButton) {
        originalButton.click();
        return;
      }
      await new Promise((resolve) => window.setTimeout(resolve, 100));
    }

    purchasePanel?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  document
    .querySelectorAll("[data-tortakit-cod-trigger]")
    .forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        openEasySell(
          trigger.closest("[data-cro-tortakit-sticky]")
            ? "sticky"
            : "purchase_panel",
        );
      });
    });

  root
    .querySelector(".product-single__add-to-cart .btn--add-to-cart")
    ?.addEventListener("click", () => {
      pushEvent("tortakit_checkout_open", {
        payment_method: "online",
        source: "purchase_panel",
      });
    });

  document
    .querySelectorAll("[data-tortakit-scroll-to-purchase]")
    .forEach((button) => {
      button.addEventListener("click", () => {
        purchasePanel?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        pushEvent("tortakit_purchase_panel_return");
      });
    });

  const updateSticky = () => {
    if (!sticky) {
      return;
    }
    const rootTop = root.getBoundingClientRect().top + window.scrollY;
    const shouldShow =
      window.scrollY > rootTop + 500 &&
      !purchaseIsVisible &&
      !finalSectionIsVisible;
    sticky.classList.toggle("is-visible", shouldShow);
    sticky.setAttribute("aria-hidden", shouldShow ? "false" : "true");
  };

  if (purchasePanel && "IntersectionObserver" in window) {
    const purchaseObserver = new IntersectionObserver(
      ([entry]) => {
        purchaseIsVisible = entry.isIntersecting;
        updateSticky();
      },
      { threshold: 0.1 },
    );
    purchaseObserver.observe(purchasePanel);
  }

  const finalSection = document.querySelector(
    ".pdp-tortakit-story__final",
  );
  if (finalSection && "IntersectionObserver" in window) {
    const finalObserver = new IntersectionObserver(
      ([entry]) => {
        finalSectionIsVisible = entry.isIntersecting;
        updateSticky();
      },
      { threshold: 0.05 },
    );
    finalObserver.observe(finalSection);
  }

  window.addEventListener("scroll", updateSticky, { passive: true });

  const reviewsSection = document.querySelector(
    ".reviews-section-wrapper",
  );
  if (reviewsSection && !document.getElementById("reviews-anchor")) {
    reviewsSection.id = "reviews-anchor";
  }

  updateVariantUi(getCurrentVariant());
  updateSticky();
})();
